import React, {Component} from 'react';
import '../../assets/css/tour.css';
import Banner from "../../widget/PageBanner";
import {Button} from 'semantic-ui-react';
import StoryArticle from "./StoryArticle.js";
import data from '../../assets/json/travelstories/miracle-at-latitude69.json';
import {Redirect} from 'react-router';

class MiracleAtLatitude69 extends Component{

	constructor(props){
		super(props);
		
		this.state = {
			data: data.miracleatlatitude69,
			redirect:false,
			routeLink: ''
		};
	}

	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	redirectTourDetails = (id) => {
		this.setState({
			redirect: true,
			routeLink: id === 1 ? '/contactus' : id === 2 ? '/travelstories' : ''
		});
	}


	
	render(){
		const {redirect, routeLink} = this.state;
		return (
			<div>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}
				<div className="half-banner-wrapper">
					<Banner pagename="MiracleAtLatitude69Story"/>
				</div>

				<div className="story-content-wrapper margin-top-5">
					<div>
						{
							this.state.data.map(
								(img, x) => (
									<StoryArticle
										index={x}
										photo1={img.photo1}
										photo2={img.photo2}
										photo3={img.photo3}
										photo4={img.photo4}
										photo5={img.photo5}
										photo6={img.photo6}
										photo7={img.photo7}
										para1={img.para1}
										para2={img.para2}
										para3={img.para3}
										para4={img.para4}
										para5={img.para5}
										para6={img.para6}
										para7={img.para7}
										para8={img.para8}
										para9={img.para9}
									/>
								)
							)
						}
					</div>
				</div>

				
				<div className="story-content-wrapper align-center">
					<Button color='orange' onClick={() => this.redirectTourDetails(1)}>Inquire now</Button>
					<Button color='orange' inverted onClick={() => this.redirectTourDetails(2)}>Check other stories</Button>

				</div>
			</div>
		);
	}
}

export default MiracleAtLatitude69;